import { jsx } from "react/jsx-runtime";
import React from "react";
var cross_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 13.4142 4.9497 4.9497 1.4142-1.4142L13.4142 12l4.9497-4.9498-1.4142-1.4142L12 10.5857 7.0502 5.636 5.636 7.0502 10.5857 12 5.636 16.9497l1.4142 1.4142L12 13.4142z"
      }
    )
  ];
};
export {
  cross_default as default
};
